var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['nocontent', { nothing: _vm.nothing }, { wsNoNontent: 'no-content' }]},[_c('img',{class:['img', { wsNoNontent: 'no-content-img' }],attrs:{"src":require("@funcPuzzle/mini_doctor/default/no-content.png")}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }